import { createAction, createSelector, createEntityAdapter, createSlice } from '@reduxjs/toolkit';

import _ from 'lodash';
import api from 'lib/api';
import utils from 'lib/utils';
import storage from 'lib/storage';
import notifications from 'lib/notifications';
import { configurationService } from 'services';

const adapter = createEntityAdapter({});

const slice = createSlice({
  name: 'loadingUnloading',
  initialState: adapter.getInitialState({
    busy: false,
    zohoDetails: [],
    gpaDetails: [],
  }),
  reducers: {
    setAll: adapter.setAll,
    addOne: adapter.addOne,
    addMany: adapter.addMany,
    updateOne: adapter.updateOne,
    updateMany: adapter.updateMany,
    upsertOne: adapter.upsertOne,
    upsertMany: adapter.upsertMany,
    removeOne: adapter.removeOne,
    removeMany: adapter.removeMany,
    removeAll: adapter.removeAll,
    setZohoDetails: (state, { payload }) => ({ ...state, zohoDetails: payload }),
    setGpaDetails: (state, { payload }) => ({ ...state, gpaDetails: payload }),
    setBusy(state, action) {
      let busy = action.payload;
      if (busy === false) {
        state.busy = false;
      } else {
        state.busy = true;
      }
    },
  },
});

const fetchList = (params) => async (dispatch) => {
  dispatch(slice.actions.setBusy(true));
  try {
    const resData = await configurationService.fetchAllLoadingUnloading(params);
    dispatch(slice.actions.setAll(resData));
  } catch (err) {
    dispatch(slice.actions.setAll({}));
    utils.displayErrors(err);
  }
  dispatch(slice.actions.setBusy(false));
};

const fetchZohoAccountCreds = (params) => async (dispatch) => {
  dispatch(slice.actions.setBusy(true));
  try {
    const resData = await configurationService.fetchZohoAccountCreds(params);
    dispatch(slice.actions.setZohoDetails(resData));
  } catch (err) {
    utils.displayErrors(err);
  }
  dispatch(slice.actions.setBusy(false));
};

const fetchZohoInvoiceLog = (params) => async (dispatch) => {
  dispatch(slice.actions.setBusy(true));
  try {
    const resData = await configurationService.fetchZohoInvoiceLog(params);
    dispatch(slice.actions.setZohoDetails(resData));
  } catch (err) {
    utils.displayErrors(err);
  }
  dispatch(slice.actions.setBusy(false));
};

const fetchZohoMappingLog = (params) => async (dispatch) => {
  dispatch(slice.actions.setBusy(true));
  try {
    const resData = await configurationService.fetchZohoMappingLog(params);
    dispatch(slice.actions.setZohoDetails(resData));
  } catch (err) {
    utils.displayErrors(err);
  }
  dispatch(slice.actions.setBusy(false));
};

const fetchZohoPaymentLog = (params) => async (dispatch) => {
  dispatch(slice.actions.setBusy(true));
  try {
    const resData = await configurationService.fetchZohoPaymentLog(params);
    dispatch(slice.actions.setZohoDetails(resData));
  } catch (err) {
    utils.displayErrors(err);
  }
  dispatch(slice.actions.setBusy(false));
};

const saveAndUpdateZohoAccountCreds = (params) => async (dispatch) => {
  dispatch(slice.actions.setBusy(true));
  try {
    const resData = await configurationService.saveAndUpdateZohoAccountCreds(params);
    return true;
  } catch (err) {
    utils.displayErrors(err);
  }
  dispatch(slice.actions.setBusy(false));
};

const createTokenForZohoAccount = (params) => async (dispatch) => {
  dispatch(slice.actions.setBusy(true));
  try {
    const resData = await configurationService.createTokenForZohoAccount(params);
    return true;
  } catch (err) {
    utils.displayErrors(err);
  }
  dispatch(slice.actions.setBusy(false));
};

const fetchGPAAcceptance = (params) => async (dispatch) => {
  dispatch(slice.actions.setBusy(true));
  try {
    const resData = await configurationService.fetchGPAAcceptance(params);
    dispatch(slice.actions.setGpaDetails(resData));
    dispatch(slice.actions.setBusy(false));
    return resData;
  } catch (err) {
    utils.displayErrors(err);
  }
  dispatch(slice.actions.setBusy(false));
};

const actions = {
  ...slice.actions,
  fetchList,
  saveAndUpdateZohoAccountCreds,
  createTokenForZohoAccount,
  fetchZohoAccountCreds,
  fetchGPAAcceptance,
  fetchZohoInvoiceLog,
  fetchZohoPaymentLog,
  fetchZohoMappingLog,
};

const selectors = {
  ...adapter.getSelectors((state) => state.loadingUnloading),
};

export { actions, selectors };

export default slice.reducer;
